import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Field, ErrorMessage } from "formik";

/* eslint-disable react/prefer-stateless-function */

const SLabel = styled.label`
  display: inline-block;
  margin-bottom: 0.5rem !important;
`;

const SField = styled(Field)`
  display: inline-block;
  width: 100%;
  height: calc(2.25rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  margin-bottom: 1rem !important;
  &:disabled {
    background-color: #dddddd !important;
  }
`;

const RedText = styled.p`
  color: red;
  animation: fadein 1s;

  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

class FormikInputField extends React.PureComponent<any, any> {

  static propTypes: {
    name: PropTypes.Requireable<string>;
    label: PropTypes.Requireable<string>;
  };

  render() {
    const { name, label, ...otherProps } = this.props;
    return (
      <React.Fragment>
        <SLabel>{label || null}</SLabel>

        <SField name={name} {...otherProps} />

        <ErrorMessage
          name={name}
          render={msg => <RedText className="error"> {msg} </RedText>}
        />
      </React.Fragment>
    );
  }
}

FormikInputField.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string
};

export default FormikInputField;
